import React, { useState } from "react";
import aboutMeData from "../data/aboutMe.json";
import contactsData from "../data/contacts.json";
import "../styles/aboutMe.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDownload,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faInfoCircle,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import {
  faGithub,
  faLinkedin,
  faTwitter,
  faTelegram,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';

const AboutMe = () => {
  const [showUpdateNotice, setShowUpdateNotice] = useState(true);
  const aboutMe = aboutMeData.aboutMe[0];
  const contacts = contactsData.contact;
  const socials = contactsData.socials;

  const socialIcons = {
    github: faGithub,
    linkedin: faLinkedin,
    twitter: faTwitter
  };

  // Map contact types to their corresponding icons
  const contactIcons = {
    'Email': faEnvelope,
    'Phone': faPhone,
    'Location': faMapMarkerAlt,
    'Telegram': faTelegram,
    'WhatsApp': faWhatsapp
  };

  // Get current date for last updated
  // const lastUpdated = "June 4, 2025"
  const lastUpdated = "Mar 9, 2025"


  return (
    <div className="compact-about-container">
      {/* Subtle update notice with close button */}
      {showUpdateNotice && (
        <div style={{
          backgroundColor: '#e7f5ff',
          color: '#1864ab',
          padding: '8px 15px',
          borderRadius: '4px',
          marginBottom: '15px',
          fontSize: '0.9em',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderLeft: '3px solid #4dabf7'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FontAwesomeIcon 
              icon={faInfoCircle} 
              style={{ marginRight: '10px' }}
            />
            <span>
              Profile updated on {lastUpdated}. Skills are continuously being added. 
              <span style={{ fontWeight: '500', marginLeft: '5px' }}>
                <a href="#contact" style={{ color: '#1864ab', textDecoration: 'underline' }}>
                  Contact me
                </a> for latest updates.
              </span>
            </span>
          </div>
          <button 
            onClick={() => setShowUpdateNotice(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#1864ab',
              cursor: 'pointer',
              padding: '5px',
              marginLeft: '10px'
            }}
            aria-label="Close notice"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}

      <div className="profile-summary">
        <img 
          src={aboutMe.imageUrl} 
          alt={aboutMe.name} 
          className="profile-avatar"
        />
        <div className="profile-heading">
          <h1>{aboutMe.name}</h1>
          <h2>{aboutMe.title}</h2>
          <p className="tagline">{aboutMe.introduction}</p>
        </div>
      </div>

      <div className="quick-info">
        <div className="info-card">
          <h3>About Me</h3>
          <p>{aboutMe.description.substring(0, 500)}...</p>
          
          {/* Subtle skills addition prompt */}
          <div style={{
            margin: '15px 0',
            fontSize: '0.9em',
            color: '#495057'
          }}>
  
          </div>
          
          <a href={aboutMe.cv} className="resume-link">
            <FontAwesomeIcon icon={faDownload} /> Resume
          </a>
        </div>

        <div className="contact-card" id="contact">
          <h3>Contact</h3>
          <div className="contact-items">
            {contacts.map((contact, index) => (
              <div key={index} className="contact-item">
                <FontAwesomeIcon 
                  icon={contactIcons[contact.type] || faEnvelope}
                  className="contact-icon"
                />
                <a href={contact.link}>{contact.displayText}</a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="social-links">
        {socials.map((social) => (
          <a
            key={social.platform}
            href={social.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`social-btn ${social.platform.toLowerCase()}`}
          >
            <FontAwesomeIcon icon={socialIcons[social.platform.toLowerCase()]} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default AboutMe;